import {RefObject, useState} from 'react'
import {debounce} from '@/utilities/helpers'

export const useInputSearch = (defaultSearchValue?: string) => {
    const [searchError, setSearchError] = useState('')
    const [searchValue, setSearchValue] = useState(defaultSearchValue ?? undefined)

    const searchCallback = (value: string) => {
        if (value?.length >= 1) {
            setSearchValue(value)
            setSearchError('')
        } else if (!value?.length) {
            setSearchValue(undefined)
            setSearchError('')
        } else {
            setSearchError('errors:search_invalid_length')
        }
    }

    const onSearch = debounce((value: string) => {
        searchCallback(value)
    }, 500)

    const onResetSearch = (searchRef: RefObject<HTMLInputElement | null>) => {
        if (searchRef.current) {
            searchRef.current.value = ''
        }

        setSearchValue(undefined)
    }

    return {
        searchValue,
        searchError,
        onSearch,
        onResetSearch
    }
}
